export default __webpack_public_path__ + "static/1.1_DE-942ea0233efbf70e95061a94fbb8cb67.webp";